import { isEmpty } from 'lodash';
import { createAction } from 'redux-actions';
import { getPermissionByDrn } from '../../service/permission';
import STATUS_CODE from '../../request/statusCode';
import { SET_PERMISSION } from './actionTypes';

const setPermission = createAction(SET_PERMISSION);

const getPermission = ({ types, actions, setPermission }) => {
  return (dispatch, getState) => {
    const { userName } = getState().account;
    const emptyPermission = {};
    types.forEach(type => {
      emptyPermission[type] = false;
    });
    if (isEmpty(userName)) {
      dispatch(setPermission(emptyPermission));
      return emptyPermission;
    }
    return getPermissionByDrn({
      principal: userName,
      actions
    }).then(res => {
      if (res.statusCode === STATUS_CODE.OK) {
        const permission = {};
        types.forEach((type, index) => {
          permission[type] = res.data[index];
        });
        dispatch(setPermission(permission));
        return permission;
      }
      dispatch(setPermission(emptyPermission));
      return emptyPermission;
    });
  };
};

export { getPermission, setPermission };
